var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagramm",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.174,
    y1: 0.885,
    x2: 0.858,
    y2: 0.078,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#f2203e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#b729a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5342d6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7428",
    "data-name": "Rectangle 7428",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17812",
    "data-name": "Group 17812",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11078",
    "data-name": "Path 11078",
    d: "M9,0H9A9,9,0,1,1,0,9,9.026,9.026,0,0,1,9,0Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11079",
    "data-name": "Path 11079",
    d: "M14.269,6H8.925A2.966,2.966,0,0,0,6,9.038v5.175A3.049,3.049,0,0,0,8.981,17.25h5.344a3.013,3.013,0,0,0,2.981-3.038V9.037A3.061,3.061,0,0,0,14.269,6Zm1.969,8.156a2.076,2.076,0,0,1-2.081,2.081H9.038a2.029,2.029,0,0,1-2.025-2.081V9.094A2.065,2.065,0,0,1,9.038,7.013h5.119a2.113,2.113,0,0,1,2.081,2.081Z",
    transform: "translate(-2.625 -2.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11080",
    "data-name": "Path 11080",
    d: "M13.724,10.9a2.869,2.869,0,0,0-.113,5.737,2.882,2.882,0,0,0,2.925-2.812v-.056A2.8,2.8,0,0,0,13.724,10.9Zm0,4.725a1.857,1.857,0,1,1-.113-3.713,1.872,1.872,0,0,1,1.913,1.8v.056A1.79,1.79,0,0,1,13.724,15.624Z",
    transform: "translate(-4.724 -4.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11081",
    "data-name": "Path 11081",
    d: "M20.819,9.4a.678.678,0,1,1-.619.675A.638.638,0,0,1,20.819,9.4Z",
    transform: "translate(-8.837 -4.112)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramm);
export default __webpack_public_path__ + "static/media/instagramm.1797fbdf7af59a141c07c702358b6d6d.svg";
export { ForwardRef as ReactComponent };